// src/pages/Meetings.js
import React from "react";
import MeetingsList from "./MeetingsList";
import { Helmet } from 'react-helmet-async';

const Meetings = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-white to-indigo-200 px-4 py-8">
      <Helmet>
        <title>Meetings - PairLingo</title>
        <meta name="description" content="Speak with perfect language partner on PairLingo." />
        <meta name="keywords" content="language learning, pairlingo, chat, match, speaking chat, german language partner chat, language speaking practice" />
      </Helmet>
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <span className="text-3xl">📅</span>
          <h2 className="text-2xl font-bold text-indigo-700">Your Upcoming Meetings</h2>
        </div>
        <MeetingsList />
      </div>
    </div>
  );
};

export default Meetings;
